import Boot from "./StarlightDawn.js"
import MobileMenu from "./MobileMenu.js"
import Runtime from "./game/Runtime.js"

const starlightDawn = new Boot(window)

window.addEventListener("DOMContentLoaded", () => {
  starlightDawn.start().then( () => {
    (new MobileMenu(document)).start()
    document.querySelectorAll("[data-reload]").forEach( (element) => {
      element.addEventListener("click", (event) => {
        event.preventDefault()
        window.location.reload()
      })
    })
    console.log(`Version ${Runtime.instance().version}`)
    document.querySelectorAll("[data-version]").forEach( (element) => {
      let label = "Version:"
      if (element.dataset["version"] && (element.dataset["version"] != "") ) {
        label = element.dataset["version"]
      }
      element.textContent = `${label} ${Runtime.instance().version}`
      element.classList.add("db")
    })
    const homeScreenMessage = document.querySelector("[data-homescreen-notification]")
    if (homeScreenMessage) {
      const isAddedToHomeScreen = window.matchMedia('(display-mode: standalone)').matches
      const isLikelyMobile      = window.matchMedia('(max-width: 30em)').matches
      const seenMessage         = window.localStorage && 
                                  window.localStorage.getItem("seenHomeScreenMessage") == "true"

      const showHomeScreenMessage = (!seenMessage && isLikelyMobile && !isAddedToHomeScreen)

      if (showHomeScreenMessage) {
        homeScreenMessage.classList.remove("dn")
        homeScreenMessage.classList.add("flex")
        if (window.localStorage) {
          window.localStorage.setItem("seenHomeScreenMessage","true")
        }
        const dismissButton = homeScreenMessage.querySelector("[data-dismiss]")
        if (dismissButton) {
          window.dismissButton = dismissButton
          dismissButton.addEventListener("click", (event) => {
            event.preventDefault()
            homeScreenMessage.classList.add("dn")
            homeScreenMessage.classList.remove("flex")
          })
        }
      }
    }
  })
})
window.addEventListener("unhandledrejection", (promiseRejectionEvent) => {
  try {
    starlightDawn.error(promiseRejectionEvent)
  } catch (error) {
    alert("Something went wrong that couldn't be recovered. See the console if you want to help")
    console.error("Bug in unhandledrejection handling:")
    console.error("PromiseRejectionEvent %o", promiseRejectionEvent)
    console.error("Error from unhandledrejection code: %o", error)
    console.error("End of handling - if you can report this to the programmer, please do")
  }

})

